import { useEffect, useState } from "react";
import GridLayout from "react-grid-layout";
import { Responsive, WidthProvider } from 'react-grid-layout';
import './react-grid-layout.scss';
const ResponsiveGridLayout = WidthProvider(Responsive);

export interface ElementLayout {
    i: string,
    x: number,
    y: number,
    w: number,
    h: number
}
export default function RedGridLayout(props: {
    elements: {
        id: string, element: () => any
    }[],
    updated: number,
    layout: ElementLayout[],
    onLayoutUpdate: (args: any[]) => void
}) {
    const [dragging, setDragging] = useState(false);
    const [spaces, setSpaces] = useState(null);
    const layout = [
        { i: "a", x: 0, y: 0, w: 1, h: 2, static: true },
        { i: "b", x: 1, y: 0, w: 3, h: 2, minW: 2, maxW: 4 },
        { i: "c", x: 4, y: 0, w: 1, h: 2 }
    ];
    useEffect(() => {
        if (props.elements && props.layout) {
            let temp = props.elements.map(el => {
                let _layout = props.layout.find(x => x.i === el.id)
                return (
                    <div key={`${el.id}`} data-grid={_layout || { x: 0, y: 2, w: 6, h: 2 }}>
                        {el.element()}
                    </div>
                )
            });
            setSpaces(temp);
        }
    }, [JSON.stringify(props?.layout || null), props.updated]);
    useEffect(() => {

    }, [])
    if (!props.layout || !props.elements) {
        return <></>
    }
    return (
        <ResponsiveGridLayout
            className="layout"
            draggableHandle=".drag-me-header"
            measureBeforeMount={false}
            onLayoutChange={(currentLayout, allLayouts) => {
                // let currentLayoutKey = Object.keys(allLayouts).filter(x => allLayouts[x] === currentLayout)[0];
                // let updated = { ...props.layout, ...allLayouts }
                // localStorage.setItem('space-pane', JSON.stringify(updated));
                // this.setState({ currentLayoutKey, loadedLayout: updated })
                console.log(currentLayout);
                console.log(allLayouts);
                props.onLayoutUpdate(currentLayout);
                // this.storeSelectedViewSetup(selectedViewSetup, allLayouts);
            }}
            onDragStart={() => {
                setDragging(true);
            }}
            onDragStop={() => {
                setDragging(false);
            }}
            onResizeStart={() => {
                setDragging(true);
            }}
            onResizeStop={() => {
                setDragging(false);
            }}
            onDrop={(layout, item) => {
                // console.log(layout);
                // console.log(item)=
                setDragging(false);
            }}
            breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
            cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}>
            {spaces}<div style={{ display: 'none' }}>{props.updated}</div>
        </ResponsiveGridLayout>
    );
}